/* src/app/_shared/components/communication-consent/communication-consent.modal.scss */
main {
  padding: var(--space-top) var(--space-right) 0 var(--space-left, var(--space-right));
}
.consent-description {
  font-size: 0.875rem;
  color: var(--ion-color-medium);
  margin: 0 0 var(--space-bottom);
  line-height: 1.5;
}
.channels-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-bottom);
}
.channels-title {
  font-size: 0.875rem;
  color: var(--ion-text-color);
}
.accept-all-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--ion-color-primary);
  font-weight: 500;
}
.communication-channels {
  display: flex;
  flex-direction: column;
}
.communication-channels ion-checkbox {
  --border-radius: 4px;
  --size: 22px;
  --checkmark-width: 3;
  width: 100%;
  padding: 14px 0;
  border-bottom: 1px solid var(--ion-color-light);
}
.communication-channels ion-checkbox:last-child {
  border-bottom: none;
}
.communication-channels ion-checkbox .checkbox-text {
  font-size: 0.9375rem;
  color: var(--ion-text-color);
}
/*# sourceMappingURL=communication-consent.modal-HFRDJ4EC.css.map */
